import React, { Component } from "react";
import whatson from './whatsonew.png';
import MEETS from './data-meets.js';
import ForumSnippet1 from "./ForumSnippet1";
import ForumSnippet2 from "./ForumSnippet2";
import ForumSnippet3 from "./ForumSnippet3";

import './whatson.css';

class Whatson extends Component {

  render() {
    return (
        <div className="whatson">
          <img src={whatson} className="App-whatson" alt="whatson" />
        <div className="top-left">
            
        {MEETS.map(item =>
            <table><td>{item.dates} <a href={item.url}>{item.title}</a></td></table>
            )}
        </div>
        <ForumSnippet1>
        </ForumSnippet1>
        <ForumSnippet2>
        </ForumSnippet2>
        <ForumSnippet3>
        </ForumSnippet3>
        </div>
        );
}
}
  

export default Whatson;



// WEBPACK FOOTER //
// ./src/Whatson.js